(function ($) {
  class Block_Result extends BD_Block {
    constructor() {
      super();

      this.type = "result_categories_score";
      this.templateID = "result-categories-score";
      this._serverSide = true;

      this.elms = {
        finishButton: "#finishButton",
        shareLinkedinButton: "#share-linkedin",
      };

      this._events = this.getEvents();

      /* custom attributes */
      this.audio = false;

      if (window.isShareLinkedin) {
        this.beforeinit();
      }
    }

    getEvents() {
      const elms = this.elms;
      return [
        {
          event: "click",
          selector: elms.finishButton,
          handler: this.onFinish,
        },
        {
          event: "click",
          selector: elms.shareLinkedinButton,
          handler: this.onShareLinkedin,
        },
      ];
    }

    beforeinit() {
      this.render();
      this.setGameState();
    }

    render() {
      const _this = this;
      const htmlTemplate = $("#" + this.templateID).html();
      let template = Handlebars.compile(htmlTemplate);

      const params = new URLSearchParams(window.location.search);
      const endpoint = window.isShareLinkedin
        ? "public/get-results-categories-score-by-id?gp-id=" + params.get("gp-id")
        : "game/get-results-categories-score";

      bdapi
        .post(endpoint)
        .then((res) => {
          const resData = res.data;
          const data = resData.data;

          const resultAndData = {
            ...data,
            ...this._data,
            isShareLinkedin: !!window.isShareLinkedin,
            gp: CFG.GP,
          };
          const html = template(resultAndData);
          $("#templateWrapper").html(html);

          bdjs.doAction("after-fetch-result-categories");

          let printChart = this.printChart;
          printChart = bdjs.applyFilters("print-chart", printChart);
          printChart(data);

          bdjs.hideLoading();
        })
        .catch((err) => {});
    }

    printChart(data) {
      const $el = document.getElementById("resultChart");
      if (!$el) return;

      var categories = data.categories;
      let ctx = $el.getContext("2d");

      const max = Math.max.apply(
        Math,
        categories.map(function (o) {
          return o.max_score;
        })
      );

      new Chart(ctx, {
        type: "bar",
        data: {
          labels: categories.map((row) => row.name),
          datasets: [
            {
              label: data.strings.label,
              data: categories.map((row) => row.score),
              backgroundColor: categories.map((row) => row.color),
              borderColor: categories.map((row) => row.color),
              borderWidth: 1,
            },
          ],
        },
        options: {
          indexAxis: "y",
          maintainAspectRatio: false,
          responsive: true,
          plugins: {
            legend: {
              display: false,
            },
          },
          scales: {
            x: {
              beginAtZero: true,
              max,
            },
          },
          ticks: {
						precision: 0
          },
        },
      });
    }

    setGameState() {}

    /* ========= ELEMENT FUNCTION HANDLER ===============*/

    onFinish() {
      BD_GAME_LOGIC.goToDefaultNextBlock();
    }

    onShareLinkedin() {
      $("#share-linkedin span").text("Please wait...");
      $(".btn-share-linkedin").addClass("is-loading");
      $(".btn").prop("disabled", true);

      const params = new URLSearchParams(window.location.search);
      const endpoint = "member/screenshot-result-categories-score?gp-id=" + CFG.GP;
      bdapi
        .post(endpoint)
        .then((res) => {
          const resData = res.data;
          const data = resData.data;
          const url = this._data.share_linkedin_url + CFG.GP;
          console.log("url", url);
          window.location.href = url;
        })
        .catch((e) => {
          console.log(e);
          alert("Failed to share");
        })
        .then(() => {
          $("#share-linkedin span").text("Share Linkedin");
          $(".btn-share-linkedin").removeClass("is-loading");
          $(".btn").prop("disabled", false);
        });
    }
  }

  return new Block_Result();
})(jQuery);
